import React from 'react'
import AttendanceSubNav from '../components/AttendanceSubNav'
import MonthlyAttendanceMonthNav from './components/MonthlyAttendanceMonthNav'
import MonthlyAttendanceMetrics from './components/MonthlyAttendanceMetrics'
import MonthlyAttendanceMatrixTable from './components/MonthlyAttendanceMatrixTable'
import SharedFilters from '../../../components/SharedFilters'
import PredefinedReportsDrawer from '../../../components/PredefinedReportsDrawer'
import useMonthlyAttendance from './hooks/useMonthlyAttendance'

export default function MonthlyAttendanceScreen() {
  const { state, actions } = useMonthlyAttendance()

  const toolsConfig = [
    { key: 'print-report', label: 'Print Report', icon: 'print' },
    { key: 'export-excel', label: 'Export Matrix to Excel', icon: 'table_view' },
    { key: 'send-sms', label: 'Send Monthly SMS', icon: 'sms' },
    { key: 'send-whatsapp', label: 'Send WhatsApp Cards', icon: 'chat' },
  ]

  return (
    <div className="mx-auto flex w-full max-w-[1460px] flex-col gap-6 pb-20">
      {/* ── Top Canopy: Header & SubNav ── */}
      <section className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-xs font-black uppercase tracking-[0.16em] text-primary">Attendance Tracking</p>
          <h1 className="mt-1 font-display text-3xl font-extrabold tracking-tight text-on-surface">
            Monthly Student Attendance Matrix
          </h1>
          <p className="mt-0.5 text-xs text-on-surface-variant">
            Consolidated month-wise attendance register with day-by-day status indicators, totals, and percentages.
          </p>
        </div>

        {/* ── Month Stepper Toolbar ── */}
        <MonthlyAttendanceMonthNav
          monthKey={state.monthKey}
          onMonthChange={actions.setMonthKey}
          onPrevMonth={actions.handlePrevMonth}
          onNextMonth={actions.handleNextMonth}
          onCurrentMonth={actions.handleCurrentMonth}
          onLastMonth={actions.handleLastMonth}
          totalDays={state.metrics.totalDays}
          workingDays={state.metrics.workingDays}
        />

      </section>



      {/* ── Monthly Summary KPI Bar ── */}
      {/* <MonthlyAttendanceMetrics metrics={state.metrics} loading={state.loading} /> */}

      {/* ── Shared Filter Accordion & Tools ── */}
      <SharedFilters
        searchField={state.searchField}
        searchText={state.searchText}
        companyFilter={state.companyFilter}
        branchFilter={state.branchFilter}
        courseFilter={state.courseFilter}
        schoolFilter={state.schoolFilter}
        academicYearFilter={state.academicYearFilter}
        batchFilter={state.batchFilter}
        subjectFilter={state.subjectFilter}
        setSearchField={actions.setSearchField}
        setSearchText={actions.setSearchText}
        setCompanyFilter={actions.setCompanyFilter}
        setBranchFilter={actions.setBranchFilter}
        setCourseFilter={actions.setCourseFilter}
        setSchoolFilter={actions.setSchoolFilter}
        setAcademicYearFilter={actions.setAcademicYearFilter}
        setBatchFilter={actions.setBatchFilter}
        setSubjectFilter={actions.setSubjectFilter}
        onReset={actions.handleResetFilters}
        onSearch={() => { }}
        searchFieldOptions={state.options.searchFields}
        companyOptions={state.options.companies}
        branchOptions={state.options.branches}
        courseOptions={state.options.courses}
        schoolOptions={state.options.schools}
        batchOptions={state.options.batches}
        subjectOptions={state.options.subjects}
        academicYearOptions={state.options.academicYears}
        visibleAccordionFilters={[
          'company',
          'branch',
          'course',
          'school',
          'academicYear',
          'batch',
          'subject',
        ]}
        tools={toolsConfig}
        onToolSelect={(key) => {
          if (key === 'print-report') {
            actions.setIsReportsOpen(true)
          } else if (key === 'export-excel') {
            actions.handleExportExcel()
          } else if (key === 'send-sms') {
            actions.handleSendSMS()
          } else if (key === 'send-whatsapp') {
            actions.handleSendWhatsApp()
          }
        }}
      />

      {/* ── Day-by-Day Monthly Matrix Table ── */}
      <MonthlyAttendanceMatrixTable
        daysMeta={state.daysMeta}
        students={state.students}
        loading={state.loading}
        onStudentClick={(student) => {
          // Future student drilldown
        }}
      />

      {/* ── Predefined Reports Drawer ── */}
      <PredefinedReportsDrawer
        isOpen={state.isReportsOpen}
        onClose={() => actions.setIsReportsOpen(false)}
        title="Monthly Attendance Reports"
        module="attendance"
        submodule="monthly"
        moduleLabel="Monthly Attendance"
        filters={{
          year: state.year,
          month: state.month,
          academicYear: state.academicYear,
          courseId: state.courseId,
          batchId: state.batchId,
          branchId: state.branchId,
          subjectId: state.subjectId,
          schoolId: state.schoolId,
        }}
      />
    </div>
  )
}
